"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = oneOf;

function oneOf(enumeration) {
  return function (value) {
    if (enumeration.indexOf(value) < 0) {
      return "Must be one of: ".concat(enumeration.join(', '));
    }

    return null;
  };
}